import language from "../language";

export default (lng) => [
  {
    label: language[lng].pending,
    value: "PENDING",
  },
  {
    label: language[lng].success,
    value: "SUCCESS",
  },
  {
    label: language[lng].failed,
    value: "FAILED",
  },
  {
    label: language[lng].requires_authorization,
    value: "REQUIRES_AUTHORIZATION",
  },
];
